/* raw layout hash: _contact-management-page-layout:1df53e474498db5a3594f43abacb4ff46a00a80a493c67477be6e7b1cb819715 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Authenticated app shell for Contacts & Groups pages.
export default function ContactManagementPageLayout() {
  return <AppShell />;
}
